import {
  DateField,
  EmailField,
  ImageField,
  SimpleShowLayout,
  TextField,
  WrapperField,
} from 'react-admin';
import { useParams } from 'react-router-dom';
import { LABELS } from 'shared/constants/labels';

export const PatientDetails = () => {
  const { avatarKey } = useParams();

  return (
    <SimpleShowLayout>
      <TextField source="firstname" label={LABELS.firstname} />
      <TextField source="lastname" label={LABELS.lastname} />
      <DateField source="dateOfBirth" label={LABELS.dateOfBirth} />
      <TextField source="gender" label={LABELS.gender} />
      <EmailField source="email" label={LABELS.email} />
      <TextField source="phone" label={LABELS.phone} />
      <TextField source="country" label={LABELS.country} />
      <TextField source="city" label={LABELS.city} />
      <WrapperField label={LABELS.avatarKey}>
        <a rel="noreferrer" href={avatarKey} target="_blank">
          <ImageField
            source="avatarKey"
            sx={{
              '& .RaImageField-image': {
                width: 300,
                height: 300,
                objectFit: 'cover',
              },
            }}
          />
        </a>
      </WrapperField>
      <TextField source="utmCampaign" label={LABELS.utmCampaign} />
      <TextField source="utmMedium" label={LABELS.utmMedium} />
      <TextField source="utmSource" label={LABELS.utmSource} />
    </SimpleShowLayout>
  );
};
